import React from 'react';
import {useSelector} from 'react-redux';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

import {CreateCandidateButton} from '../../CandidateProfile/CreateCandidateButton/CreateCandidateButton';

import {useCandidatesSection} from './CandidatesSection.hook';
interface CandidatesSectionProps {
  onShowInfoPopover: () => void;
  onShowReport: () => void;
  allCandidatesCount: number | null;
  referralsCount: number | null | undefined;
  onNavigate: () => void;
}

export const CandidatesSection = ({
  onShowInfoPopover = () => {},
  onShowReport = () => {},
  allCandidatesCount = null,
  referralsCount = null,
  onNavigate = () => {},
}: CandidatesSectionProps) => {
  const featureFlag = useSelector(variablesFeatureFlag);

  const {listItems, onInfoPress, onItemPress, ts} = useCandidatesSection({
    onShowInfoPopover,
    onShowReport,
    allCandidatesCount,
    referralsCount,
  });
  return (
    <>
      <MetricSection
        analyticsTitle="Candidates"
        infoAccessibilityLabel={ts(
          'accessibilityLabel',
          'Candidates Section Information button',
        )}
        title={ts('heading', 'Candidates')}
        listItems={listItems}
        onInfoPress={onInfoPress}
        onItemPress={onItemPress}
        testID={MetricsSection.metricSectionCandidates}
      />
      {featureFlag.showAddCandidate && (
        <CreateCandidateButton onNavigate={onNavigate} />
      )}
    </>
  );
};

export default CandidatesSection;
